import axios from "axios";
import qs from "qs";
import { Toast } from "vant";
import { getQueryString, h5Platform, getCookieAddressInfo } from "../utils";
import { checkLeFuXcx, checkXcx } from "../utils/checkXcx";
import {
  checkLogin,
} from "../assets/js/api";

// let baseURL;

let appAPI; // 网关
let mallAPI; // 接口
const { NODE_ENV, VUE_APP_FLAG } = process.env;

if (NODE_ENV === "production") {
  if (/test\d{2}$/g.test(VUE_APP_FLAG)) {
    // baseURL = `http://api.${VUE_APP_FLAG}.com`;
    if (VUE_APP_FLAG === "test05") {
      appAPI = "/gw/app";
      mallAPI = "/api";
    } else {
      appAPI = `http://appzuul.${VUE_APP_FLAG}.com`;
      mallAPI = `http://api.${VUE_APP_FLAG}.com`;
    }
  } else {
    // baseURL = "/api";
    appAPI = "/gw/app";
    mallAPI = "/api";
  }
} else {
  // baseURL = "http://10.8.3.17/api";
  // baseURL = "http://api.test02.com";
  // baseURL = "https://m.dongfangfuli.com/api";
  // appAPI = `http://appzuul.test04.com`;
  // mallAPI = `http://api.test02.com`;
  // appAPI = `http://m.stage.dongfangfuli.com/gw/app`;
  // mallAPI = `http://m.stage.dongfangfuli.com/api`;
  // appAPI = 'http://m.test03.com/gw/app';
  // mallAPI = 'http://m.test03.com/api'
  appAPI = "/gw/app";
  mallAPI = "/api";
}
/**
 * 创建一个axios实例
 */
const _axios = axios.create({
  withCredentials: true,
  timeout: 60000
  // headers: {
  //   "Content-Type": "application/x-www-form-urlencoded"
  // }
});

// _axios.defaults.headers.common["__consumerName"] = "h5/search";

// 请求前添加拦截器
const _axios_req = _axios.interceptors.request.use(
  function(config) {
    // 1. 在发送请求之前做些什么
    // Toast.loading({
    //   duration: 0,
    //   message: "加载中..."
    // });

    // 2. 如果是工会的，请求中带入工会值
    const union = getQueryString("union");
    const addr = getCookieAddressInfo();
    const city = addr && addr.cityId ? addr.cityId : getQueryString("city") ? getQueryString("city") : 145;

    let params;
    if (union && union !== "stage") {
      params = {
        union,
        platform: 1,
        subPlatform: h5Platform(),
        unionFlag: 1,
        city: city,
        cityId: city
      };
      config.data = { ...params, ...config.data };
    } else {
      params = {
        platform: 1,
        subPlatform: h5Platform(),
        city: city,
        cityId: city
      };
      config.data = {
        ...params,
        ...config.data,
        innerH5: checkXcx() && !checkLeFuXcx() ? 1 : null // 是否是频道内搜索嵌入小程序场景
      };
    }
    return config;
  },
  function(error) {
    // 对请求错误做些什么
    return Promise.reject(error);
  }
);

// 响应后添加拦截器
const _axios_res = _axios.interceptors.response.use(
  function(response) {
    // 对响应数据做点什么
    // Toast.clear();
    if (response && response.data && (response.data.code ===1000000 || response.data.code ===1000001)){
      checkLogin().then(res=>{
        const loginUrl  = res && res.data && res.data.loginUrl? res.data.loginUrl: '';
        window.dfShowGuestModal((type) => {
          console.log('停留当前页面不处理')
        }, loginUrl,response.data.code);
      });
    }
    return response;
  },
  function(error) {
    // 对响应错误做点什么
    return Promise.reject(error);
  }
);

/**
 * 封装获取数据的请求方法
 * @param { String } url   接口路径
 * @param { Object } params 请求的参数
 * @param  { Boolean } immediate 区别mallAPI和appAPI接口
 * @param { Boolean } needAddress 是否需要四级地址入参
 */
export function getPost(url, params, immediate = true, needAddress = true, needAddressName = false) {
  const addr = getCookieAddressInfo();
  let info = {}
  if (addr && addr.cityId) {
    info = {
      provinceId: addr.provinceId,
      cityId: addr.cityId,
      regionId: addr.regionId || addr.districtId,
      streetId: addr.streetId,

      provinceName: addr.provinceName,
      cityName: addr.cityName,
      regionName: addr.regionName,
      streetName: addr.streetName,
    }
  }

  if (needAddressName) {
    info = {
      ...info,
      provinceName:  addr.provinceName,
      cityName:  addr.cityName,
      regionName:  addr.regionName,
      streetName:  addr.streetName,
    }
  }

  return _axios({
    url,
    method: "POST",
    data: needAddress ? {...params, ...info} : params,
    baseURL: immediate ? mallAPI : appAPI,
    transformRequest: [
      function(data) {
        return immediate
          ? qs.stringify(data, { allowDots: true })
          : JSON.stringify(data);
      }
    ],
    headers: {
      'terminal': window.navigator.userAgent.indexOf("MAX-APP") > -1
          ? "maxapp"
          : null,
      "Content-Type": immediate
        ? "application/x-www-form-urlencoded"
        : "application/json"
    }
  }).catch(err => {
    Toast.fail(TLang(err.message, "error"));
  });
}

export function getParamsfilterEmpty(arg) {
  const params = {...arg};
  const keys = Object.keys(params);
  keys.forEach((t) => {
    if (t === "productTypes") {
      // 因为接口出参跟入参不一致，现在写死强制转换
      // if (params[t] === '线下商户') {
      //   params[t] = '美食汇'
      // }
      // 因为接口迁移,后台要数组形式,后台调研此字段只会有一个值
      if ((params[t] === "" || params[t] === undefined) && !Array.isArray(params[t])) {
        params[t] = null
      } else if ((params[t] !== "" || params[t] !== undefined) && !Array.isArray(params[t])) {
        params[t] = params[t].split(",")
      }
    } else if (typeof (params[t]) == 'string' && params[t] === '') {
      params[t] = null
    }
  });
  return params
}
export { _axios, _axios_req, _axios_res };
